import { MARKETING_CAMPAIGN_STATUS } from './marketingCampaignStatus';
import { parseCampaignSenderIdField } from './marketingSenderOptions';

const DUPLICATE_NAME_SUFFIX = '_copy';

function normalizeIdValue(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? value : numericValue;
}

/**
 * Builds a POST `mailing/v2/campaign` create body (no `id`): `name`, `senderId`, `subject`, `body`,
 * `status`, `previewText`, optionally `metadata` if design is copied — aligned with MarketingCampaignsForm.
 *
 * `copyRecipients` is accepted for UI parity only (not a separate key on this contract).
 *
 * @param {object} source — result of `EntityCrudService.get(CAMPAIGNS_MARKETING, id)`
 * @param {object} flags
 * @param {boolean} [flags.copySender]
 * @param {boolean} [flags.copyRecipients]
 * @param {boolean} [flags.copySubject]
 * @param {boolean} [flags.copyDesign]
 * @param {boolean} [flags.copyAdditionalSettings]
 */
export function buildMarketingCampaignDuplicateCreatePayload(source, flags) {
    if (!source || typeof source !== 'object') {
        throw new Error(
            'buildMarketingCampaignDuplicateCreatePayload: source campaign is required',
        );
    }

    const {
        copySender = true,
        copySubject = true,
        copyDesign = false,
        copyAdditionalSettings = false,
    } = flags || {};

    const baseName = (source.name || '').trim();
    const name = baseName ? `${baseName}${DUPLICATE_NAME_SUFFIX}` : DUPLICATE_NAME_SUFFIX;

    const senderParsed = parseCampaignSenderIdField(source.senderId);
    const senderId = copySender ? normalizeIdValue(senderParsed.id) : null;

    const previewText = copyAdditionalSettings ? (source.previewText || '').trim() : '';

    const payload = {
        name,
        senderId,
        subject: copySubject ? (source.subject || '').trim() : '',
        body: copyDesign ? source.body || '' : '',
        status: MARKETING_CAMPAIGN_STATUS.DRAFT,
        previewText,
    };

    if (copyDesign && source.metadata != null) {
        payload.metadata = source.metadata;
    }

    return payload;
}
